import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { BillingScope } from 'apps/picflow/src/app/billing-consts';
import { StateService } from 'apps/picflow/src/app/services/state.service';
import { BadgeComponent } from '../../../../components/badge/badge.component';
import { UpgradeBadgeComponent } from '../../../../shared-extra/components/pro-tag/upgrade-badge.component';
import { BillingScopePipe } from '../../../../shared-extra/pipes/billing-scope.pipe';

@Component({
  selector: 'app-action-box-content',
  templateUrl: './action-box-content.component.html',
  styleUrls: ['./action-box-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UpgradeBadgeComponent, BillingScopePipe, BadgeComponent],
})
export class ActionBoxContentComponent {
  public state = inject(StateService);
  @Input() title: string;
  @Input() soon: boolean;
  @Input() small: boolean;
  @Input() scope: BillingScope;
  @Input() gallery: GalleryDto;
  @Input() location: string;
}
